import {
  MOCKAUTHACCOUNTS,
  MOCKAUTHENABLED,
  MOCKAUTHTOKENPREFIX,
} from "../constants/mock-auth-constant";
import { LOCALSTORAGEAUTHUSERINFO } from "../constants/browser-storage-constant";
import { getDataFromLocalStorage } from "./views-utils";

export const isMockAuthEnabled = () => MOCKAUTHENABLED;

/** Returns the mock account matching the submitted credentials, or null. */
export const findMockAuthAccount = (email: any, password: any) => {
  if (!MOCKAUTHENABLED) return null;
  const normalisedEmail = String(email ?? "")
    .trim()
    .toLowerCase();
  return (
    MOCKAUTHACCOUNTS.find(
      (account) => account.email === normalisedEmail && account.password === password
    ) ?? null
  );
};

/**
 * Builds the same payload shape the real login endpoint stores, so the route
 * guards, the auth slice and every `auth.role` check behave identically.
 */
export const buildMockAuthSession = (account: any): any => ({
  token: `${MOCKAUTHTOKENPREFIX}${account.user.userId}`,
  refreshToken: `${MOCKAUTHTOKENPREFIX}refresh.${account.user.userId}`,
  user: account.user,
  message: "signin successfull",
  success: "signin successfull",
  role: [account.role],
});

/** True while the browser holds a locally issued session. */
export const isMockAuthSessionActive = () => {
  if (!MOCKAUTHENABLED) return false;
  const auth = getDataFromLocalStorage(LOCALSTORAGEAUTHUSERINFO);
  return String(auth?.token ?? "").startsWith(MOCKAUTHTOKENPREFIX);
};
